// src/components/ui/CardContent.jsx

import React from 'react';

/**
 * Componente CardContent minimalista e limpo. 
 * Aplica espaçamento interno ao conteúdo do Card.
 */
const CardContent = React.forwardRef(({ className = '', ...props }, ref) => (
  <div
    ref={ref}
    // Classes Tailwind:
    // - p-6: Padding padrão em todas as direções.
    // - pt-0: Remove o padding superior, útil para Cards que usam CardHeader.
    className={`p-6 pt-0 ${className}`}
    {...props}
  />
));

CardContent.displayName = "CardContent";

export default CardContent;